import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert, Progress } from 'reactstrap';

const ScheduleGenerationModal = ({ 
  isOpen, 
  taskId, 
  status, 
  message, 
  output, 
  errors, 
  orgName, 
  leagueName, 
  createdAt, 
  startedAt, 
  completedAt, 
  failedAt,
  onStart,
  onClose 
}) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'success';
      case 'completed_with_errors':
        return 'warning';
      case 'failed':
        return 'danger';
      case 'running':
        return 'info';
      case 'ready':
        return 'primary';
      case 'pending':
      default:
        return 'secondary';
    }
  };
  
  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return '✓';
      case 'completed_with_errors':
        return '⚠';
      case 'failed':
        return '✗';
      case 'running':
        return '⟳';
      case 'ready':
        return '▶';
      case 'pending':
      default:
        return '○';
    }
  };
  
  const isJobInProgress = (status) => {
    return status === 'pending' || status === 'running';
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>
        Schedule Generation Status
      </ModalHeader>
      <ModalBody>
        {taskId && (
          <div className="mb-3">
            <small className="text-muted">Task ID: {taskId}</small>
          </div>
        )}
        
        <div className="mb-3">
          <strong>Organization:</strong> {orgName}<br />
          <strong>League:</strong> {leagueName}
        </div>
        
        <Alert color={getStatusColor(status)} className="d-flex align-items-center">
          <span style={{ fontSize: '1.5rem', marginRight: '10px' }}>
            {getStatusIcon(status)}
          </span>
          <div>
            <strong>Status:</strong> {status || 'Unknown'}
            {message && (
              <>
                <br />
                <span>{message}</span>
              </>
            )}
          </div>
        </Alert>
        
        {isJobInProgress(status) && (
          <div className="mb-3">
            <Progress animated color="info" value={100} />
            <small className="text-muted">Processing... Please wait.</small>
          </div>
        )}
        
        {output && (
          <div className="mb-3">
            <strong>Output:</strong>
            <pre className="bg-light p-2 rounded" style={{ maxHeight: '200px', overflow: 'auto' }}>
              {output}
            </pre>
          </div>
        )}
        
        {errors && (
          <div className="mb-3">
            <strong>Errors:</strong>
            <Alert color="danger">
              <pre style={{ maxHeight: '200px', overflow: 'auto', marginBottom: 0 }}>
                {errors}
              </pre>
            </Alert>
          </div>
        )}
        
        <div className="mt-3">
          <small className="text-muted">
            {createdAt && (
              <>Created: {new Date(createdAt).toLocaleString()}<br /></>
            )}
            {startedAt && (
              <>Started: {new Date(startedAt).toLocaleString()}<br /></>
            )}
            {completedAt && (
              <>Completed: {new Date(completedAt).toLocaleString()}<br /></>
            )}
            {failedAt && (
              <>Failed: {new Date(failedAt).toLocaleString()}<br /></>
            )}
          </small>
        </div>
      </ModalBody>
      <ModalFooter>
        {status === 'ready' && (
          <Button 
            color="primary" 
            onClick={onStart}
          >
            Start Generation
          </Button>
        )}
        <Button 
          color="secondary" 
          onClick={onClose}
          disabled={isJobInProgress(status)}
        >
          {isJobInProgress(status) ? 'Processing...' : 'Close'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ScheduleGenerationModal;
